module.exports = __webpack_public_path__ + "static/media/express.02e77b1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/skill/express.png
// module id = 113
// module chunks = 0